module.exports = "/dist/assets/images/mstile-150x150.png";